import React, { useState } from 'react';
import Icon from '../ui/AppIcon';
import { usePWA } from '../../hooks/usePWA';

export default function PWAInstallButton({
  className = '',
  label = 'Install App',
  variant = 'primary',
}) {
  const { isInstalled, requestInstall, isInstallPending, canInstall } = usePWA();
  const [isInstalling, setIsInstalling] = useState(false);

  const handleClick = async () => {
    setIsInstalling(true);
    try {
      await requestInstall();
    } finally {
      setIsInstalling(false);
    }
  };

  const busy = isInstalling || isInstallPending;

  const buttonClass =
    variant === 'white'
      ? 'bg-white hover:bg-gray-100 text-[#003087] font-bold px-8 py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl'
      : 'bg-gradient-to-r from-[#e8471e] to-[#ff5722] hover:from-[#c73a17] hover:to-[#e8471e] text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl';

  if (isInstalled) {
    return (
      <div className={`flex items-center gap-2 text-green-600 font-semibold ${className}`}>
        <Icon name="CheckCircleIcon" size={18} />
        App Installed
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className={`inline-flex items-center justify-center gap-2 min-h-[52px] disabled:opacity-70 ${buttonClass} ${className}`}
    >
      <Icon name="ArrowDownTrayIcon" size={20} />
      {busy ? 'Downloading...' : canInstall ? label : label}
    </button>
  );
}
